$(function () {
  let params = location.search.substring(1).split('&');
  $.each(params, function (index, val) {
    let key = val.split('=');
    if (key[0] == 'new_flg' || key[0] == 'sale_flg' || key[0] == 'recommend_flg' || key[0] == 'b_grade_flg' || key[0] == 'generic_flg' || key[0] == 'original_flg') {
      if (key[1] == 1) {
        let i = key[0].slice(0, -4);
        let ele = $('#' + i);
        ele.addClass('checked');
        ele.trigger("click");
      }
    }
  });

  // 金額の絞り込みフォームのバリデーション
  $('.number_validation').on('input', function() {
    // マイナスを入力できないようにします。
    let value = $(this).val();
    if(Math.abs(value) == 0) {
        $(this).val('');
    }

    // 100万以上は入力できないようにします。
    let maxlength = 6;
    if($(this).val().length > maxlength) {
        $(this).val($(this).val().slice(0, maxlength));
    }
  });

  $('input[type=checkbox]').click(function () {
    $(this).toggleClass('checked');
  });

  $('#refinement-btn').click(function () {
    let route = '';
    let url = location.search;
    url = url.substring(1).split('&');

    $.each(url, function (index, val) {
      if (val.indexOf('category_code') !== -1 || val.indexOf('keyword') !== -1 || val.indexOf('related_product') !== -1) {
        route = '?' + val;
      }
    });

    let params_check = {};
    params_check['new_flg'] = $('[name="new"]').hasClass('checked') ? 1 : 0;
    params_check['sale_flg'] = $('[name="sale"]').hasClass('checked') ? 1 : 0;
    params_check['recommend_flg'] = $('[name="recommend"]').hasClass('checked') ? 1 : 0;
    params_check['b_grade_flg'] = $('[name="b_grade"]').hasClass('checked') ? 1 : 0;
    params_check['generic_flg'] = $('[name="generic"]').hasClass('checked') ? 1 : 0;
    params_check['original_flg'] = $('[name="original"]').hasClass('checked') ? 1 : 0;
    params_check['min_price'] = $('[name=min_price]').val();
    params_check['max_price'] = $('[name=max_price]').val();

    $.each(params_check, function (index, val) {
      if (val) {
        if (route === '') {
          route = '?' + index + '=' + val;

        } else if (route.indexOf('?') !== 1) {
          route = route + '&' + index + '=' + val;
        }
      }
    });

    window.location.href = '/item/list' + route;
  });
});
